import { IApplicationState } from '../types/redux';

export const selectCurrentRealtor = (state: IApplicationState) => state.realtors.currentRealtor;
